<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
    <h1 class="h2">
        <i class="fa-solid fa-address-card me-2"></i>
        <ng-container *ngIf="viewMode == ViewMode.INSERT">Kontakt anlegen</ng-container>
        <ng-container *ngIf="viewMode == ViewMode.EDIT">Kontakt bearbeiten</ng-container>
        <ng-container *ngIf="viewMode == ViewMode.VIEW">Kontakt</ng-container>
    </h1>
</div>

<form [formGroup]="form">
    <label>Kunde</label>
    <select class="form-control" formControlName="id_customer" *ngIf="viewMode != ViewMode.VIEW">
        <option value="">Keiner</option>
        <option *ngFor="let customer of customers" [ngValue]="customer.id">
            {{ customer.name }}
        </option>
    </select>
    <p *ngIf="viewMode == ViewMode.VIEW">
        <a *ngIf="form.value.id_customer" [routerLink]="['/customer', form.value.id_customer]">{{ form.value.customer }}</a>
        <span class="text-muted" *ngIf="!form.value.id_customer">Nicht gesetzt</span>
    </p>

    <div class="row">
        <div class="col">
            <label>Name</label>
            <input type="text" class="form-control" formControlName="name" *ngIf="viewMode != ViewMode.VIEW">
            <p *ngIf="viewMode == ViewMode.VIEW">{{ form.value.name }}</p>
        </div>
        <div class="col">
            <label>PLZ</label>
            <input type="number" class="form-control" formControlName="zip" *ngIf="viewMode != ViewMode.VIEW">
            <p *ngIf="viewMode == ViewMode.VIEW">
                {{ form.value.zip }}
                <span class="text-muted" *ngIf="!form.value.zip">Nicht gesetzt</span>
            </p>
        </div>
    </div>

    <div class="row">
        <div class="col">
            <label>Ort</label>
            <input type="text" class="form-control" formControlName="city" *ngIf="viewMode != ViewMode.VIEW">
            <p *ngIf="viewMode == ViewMode.VIEW">
                {{ form.value.city }}
                <span class="text-muted" *ngIf="!form.value.city">Nicht gesetzt</span>
            </p>
        </div>
        <div class="col">
            <label>Straße</label>
            <input type="text" class="form-control" formControlName="street" *ngIf="viewMode != ViewMode.VIEW">
            <p *ngIf="viewMode == ViewMode.VIEW">
                {{ form.value.street }}
                <span class="text-muted" *ngIf="!form.value.street">Nicht gesetzt</span>
            </p>
        </div>
    </div>

    <div class="row">
        <div class="col">
            <label>Telefon</label>
            <input type="text" class="form-control" formControlName="phone" *ngIf="viewMode != ViewMode.VIEW">
            <p *ngIf="viewMode == ViewMode.VIEW">
                <a [href]="'tel:' + form.value.phone">{{ form.value.phone }}</a>
                <span class="text-muted" *ngIf="!form.value.phone">Nicht gesetzt</span>
            </p>
        </div>
        <div class="col">
            <label>E-Mail</label>
            <input type="text" class="form-control" formControlName="mail" *ngIf="viewMode != ViewMode.VIEW">
            <p *ngIf="viewMode == ViewMode.VIEW">
                {{ form.value.mail }}
                <span class="text-muted" *ngIf="!form.value.mail">Nicht gesetzt</span>
            </p>
        </div>
    </div>
</form>

<div style="border-top: 1px solid #dee2e6" class="mt-3 py-3">
    <ng-container *ngIf="viewMode == ViewMode.VIEW">
        <button type="button" class="btn btn-primary me-2" (click)="setMode(ViewMode.EDIT)">Bearbeiten</button>
        <button type="button" class="btn btn-secondary" (click)="cancel()">Zurück</button>
        <button type="button" class="btn btn-danger float-end" (click)="delete()">Löschen</button>
    </ng-container>

    <ng-container *ngIf="viewMode == ViewMode.EDIT">
        <button type="button" class="btn btn-success" [disabled]="form.invalid" (click)="update()">Aktualisieren</button>
        <button type="button" class="btn btn-secondary ms-2" (click)="cancelEdit()">Abbrechen</button>
    </ng-container>

    <ng-container *ngIf="viewMode == ViewMode.INSERT">
        <button type="button" class="btn btn-success" [disabled]="form.invalid" (click)="save()">Speichern</button>
        <button type="button" class="btn btn-secondary ms-2" (click)="cancel()">Abbrechen</button>
    </ng-container>
</div>
